import { render, staticRenderFns } from "./KeyboardShortcutsHelpModal.vue?vue&type=template&id=087e4eaf&"
import script from "./KeyboardShortcutsHelpModal.vue?vue&type=script&lang=ts&"
export * from "./KeyboardShortcutsHelpModal.vue?vue&type=script&lang=ts&"
import style0 from "./KeyboardShortcutsHelpModal.vue?vue&type=style&index=0&id=087e4eaf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports